import React, { useCallback } from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface NatureOfBusinessInputProps {
  // Controlled pattern (used by JourneyPage)
  value?: { nature_of_business?: string | null };
  onChange?: (val: { nature_of_business: string }) => void;
  disabled?: boolean;
  // Legacy pattern
  initialData?: { nature_of_business?: string };
  onDataChange?: (data: { nature_of_business: string }) => void;
}

const NATURE_OPTIONS = ["Agriculture", "Manufacturing", "Professional", "Salaried", "Services"];

const NatureOfBusinessInput: React.FC<NatureOfBusinessInputProps> = ({
  value,
  onChange,
  disabled,
  initialData,
  onDataChange,
}) => {
  const currentValue = (value?.nature_of_business ?? initialData?.nature_of_business ?? '') || '';

  const handleChange = useCallback((val: string) => {
    onChange?.({ nature_of_business: val });
    onDataChange?.({ nature_of_business: val });
  }, [onChange, onDataChange]);

  return (
    <div className="space-y-1.5">
      <Label className="text-gray-500 font-medium">Nature of Business</Label>
      <Select value={currentValue || undefined} onValueChange={handleChange} disabled={disabled}>
        <SelectTrigger className="border-gray-200 focus:border-intellend-green focus:ring-intellend-green rounded-xl py-6">
          <SelectValue placeholder="Select nature of business" />
        </SelectTrigger>
        <SelectContent>
          {NATURE_OPTIONS.map((opt) => (
            <SelectItem key={opt} value={opt}>{opt}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default NatureOfBusinessInput;
